<template>
  <el-container class="order-analysis">
    <el-header class="header-style">
      <el-divider content-position="left">订单地区分析列表</el-divider>
      <el-row style="margin-bottom: 0.4rem">
        <el-col :span="2" style="margin: 8px 0 0 8px">号码归属地</el-col>
        <el-col :span="3">
          <el-select
            size="mini"
            v-model="searchArr.province"
            placeholder="请输入省份"
            remote
            reserve-keyword
            clearable
            filterable
            :remote-method="remoteGetProvince"
            :loading="loading"
          >
            <el-option
              v-for="(item, index) in searchSingleProvince"
              :key="index"
              :label="item.province"
              :value="item.province"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin: 8px 0 0 1rem"><span>订单录入时间</span></el-col>
        <el-col :span="6" style="margin-left: 0.4rem">
          <el-date-picker
            size="mini"
            v-model="searchArr.created_at"
            type="daterange"
            :picker-options="createdPicker"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="2" style="margin: 8px 0 0 1rem"><span>订单来源</span></el-col>
        <el-col :span="6">
          <el-select
            v-model="searchArr.platform"
            filterable
            placeholder="请选择"
            clearable
            multiple
            size="small"
            @click.native="getFrom"
          >
            <el-option
              v-for="item in fromOptions"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 0.4rem">
        <el-col :span="2" style="margin: 8px 0 0 8px">订单类型</el-col>
        <el-col :span="3">
          <el-select
            v-model="searchArr.orderRegType"
            multiple
            filterable
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="orderReg in orderRegs"
              :key="orderReg.order_reg_id"
              :label="orderReg.order_reg_name"
              :value="orderReg.order_reg_id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin: 8px 0 0 1rem">单品</el-col>
        <el-col :span="6" style="margin-left: 0.4rem">
          <el-select
            v-model="searchArr.mealSingles"
            multiple
            filterable
            placeholder="请选择"
            size="mini"
            clearable
          >
            <el-option
              v-for="mealSingle in mealSingles"
              :key="mealSingle.item_id"
              :label="mealSingle.item_name"
              :value="mealSingle.item_id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin: 8px 0 0 1rem">客户来源</el-col>
        <el-col :span="6">
          <el-select
            v-model="searchArr.sources"
            multiple
            filterable
            placeholder="请选择"
            clearable
            size="mini"
          >
            <el-option
              v-for="option in sources"
              :key="option.source_id"
              :label="option.source_name"
              :value="option.source_id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="text-align: center; margin-bottom: 0.4rem">
        <el-col>
          <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
          <el-button type="danger" size="mini" @click="handleASearClear">清除</el-button>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table
        :data="pageData"
        size="medium"
        style="width: 100%"
        @sort-change="changeSort"
      >
        <el-table-column label="省份" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.province ? scope.row.province : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总计" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.total ? scope.row.total : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="沟通中" prop="communicating" sortable width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务中" prop="serving" sortable width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.num1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系不到" prop="nocontact" sortable width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.num2 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已退款" prop="refunded" sortable width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.num3 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务完成" prop="served" sortable width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.num4 }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <!-- <div class="block" style="margin-top: 10px; text-align: right">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :hide-on-single-page="false"
          :current-page="pageOption.currentPage"
          layout="sizes, total, prev, pager, next, jumper"
          :total="pageOption.total"
          :page-sizes="[10, 15, 30, 50, 100]"
          :page-size="pageOption.pageSize"
          background
        >
        </el-pagination>
      </div> -->
  </el-container>
</template>

<script>
export default {
  name: "OrderAreaAnalysis",
  data() {
    return {
      searchArr: {
        province: "",
        platform: "",
        created_at: "",
        prop: "",
        sort: "communicating",
        orderRegType: [],
        mealSingles: [],
        sources: null,
      },
      mealSingles: [],
      orderRegs: [],
      sources: [],
      fromOptions: [],
      pageData: [],
      loading: false,
      searchSingleProvince: [],
      searchSingleCity: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      createdPicker: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterDate = this.yesterday();
              picker.$emit("pick", yesterDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    handelGetOrders() {
      this.$axios
        .get("/api/admin/order_area_analysis?param=" + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData = data.data;
            this.orderRegs = data.orderRegs;
            this.mealSingles = data.mealSingles;
            this.sources = data.sources;
          }
        });
    },
    changeSort(e) {
      // console.log(e)
      // console.log(e.order.order)
      this.searchArr.prop = e.prop;
      this.searchArr.sort = e.order;
      this.handelGetOrders();
    },
    // 搜索
    handleASearSub() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    remoteGetProvince(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchProvince(query);
        }, 200);
      } else {
        this.searchSingleProvince = [];
      }
    },
    searchProvince(query) {
      this.$axios
        .get("/api/admin/tel_isp/get_province_isp?keyword=" + query)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.searchSingleProvince = data.data.searchSingleProvince;
          }
        });
    },
    remoteGetCity(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCity(query);
        }, 200);
      } else {
        this.searchSingleCity = [];
      }
    },
    searchCity(query) {
      this.$axios.get("/api/admin/tel_isp/get_city_isp?keyword=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchSingleCity = data.data.searchSingleCity;
        }
      });
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_froms")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    handleASearClear() {
      this.searchArr.created_at = "";
      this.searchArr.province = "";
      this.searchArr.city = "";
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    prevWeek() {
      var end = new Date();
      var start = new Date();
      var lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);

      return [start, end];
    },
    today() {
      return [new Date(), new Date()];
    },
    yester() {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);

      return [date, date];
    },
    thisMon() {
      var end = new Date();
      var start = new Date();
      // 方法1
      var endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    lastMon() {
      var end = new Date();
      var start = new Date();
      var year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      var febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天

      return [start, end];
    },
  },
  mounted() {
    this.handelGetOrders();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.order-analysis >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.order-analysis >>> .el-timeline-item__node--normal
  left: 0
.order-analysis >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.order-analysis
  marginLeft()
  max-height: 100vh;
  .header-style
    z-index: 2;
    height: 200px !important;
    padding: 0px !important;
  .main-style
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
.order-analysis >>> .el-table th>.cell
  padding-left: .28rem
.el-select, .el-cascader
  width: 100%
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.el-card__body p
  margin-top: .4rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.mt-50
  margin-top: 1rem
.mb-10
  margin-bottom: .2rem
.ml-10
  margin-left: .2rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-date-editor
  width: 100% !important
.check-succ
  color: #67C23A
.bottom-btn
  padding: .2rem
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/order_area_analysis/OrderAreaAnalysis.vue